const primitives = {
  drawDot: function (x, y, size = 1) {
    this.beginPath();
    this.arc(x, y, size, 0, Math.PI * 2);
  },
};

export const bootloadPrimitives = (ctx) => {
  Object.keys(primitives).forEach((key) => {
    ctx[key] = primitives[key];
  });

  return ctx;
};
